const async = require('../odo-async')
const diff = require('./diff')
const optimise = require('./optimise')
const parallelqueries = require('./parallelqueries')
const structuredClone = require('@ungap/structured-clone').default

module.exports = (exe, options) => {
  const log = options?.hub
    ? (message => options.hub.emit('[odoql-exe] {message}', { message }))
    : () => {}
  options = options ?? {}
  options.maxparallelqueries = options.maxparallelqueries ?? 5
  const _cached = {}
  const _e = { ready: [], result: [], error: [] }
  const pq = parallelqueries(options.maxparallelqueries, timings => {
    for (const e of _e.ready) e(timings)
  })
  const res = () => {}
  res.apply = queries => Object.assign(_cached, queries)
  res.run = queries => {
    // console.log('_cached', JSON.stringify(_cached, null, 2))
    // console.log('queries', JSON.stringify(queries, null, 2))
    queries = diff(_cached, queries)
    if (Object.keys(_cached).length > 0) log(`${(Object.keys(_cached).join(', '))} in the cache`)
    if (Object.keys(queries).length > 0) log(`${(Object.keys(queries).join(', '))} new or changed`)
    Object.assign(_cached, structuredClone(queries))
    const optimisedqueries = optimise(exe, queries)
    const fn = query => {
      if (query.isAsync) {
        const update = {}
        for (const key of query.keys) update[key] = null
        for (const e of _e.result) e(update)
      }
      const callback = cb => {
        query.query((errors, results) => {
          if (errors != null) {
            log(`${(Object.keys(errors).join(', '))}errored`)
            for (const key of Object.keys(errors)) log(`${key}: ${errors[key]}`)
            for (const e of _e.error) e(errors)
          }
          cb(errors, keys => {
            log(`${(keys.join(', '))}complete, caching`);
            const update = {}
            for (const key of keys) update[key] = results[key] ?? null
            for (const e of _e.result) e(update)
          })
        })
      }
      pq.add(query.isAsync, query.keys, callback);
    }
    for (const q of optimisedqueries) fn(q)
    async.delay(() => pq.exec())
  }
  res.on = (e, cb) => {
    if (_e[e] == null) _e[e] = []
    _e[e].push(cb)
  }
  return res
};
